<div class="date-container">
  <ul class="date-list">
    <li 
      *ngFor="let item of siteAdvertDays"
      (click)="selectDate(item.pubDate, item.soldOut, item.UserObj)"
      [ngClass]="{
        'sold-out': item.soldOut, 
        'isCommonUser': item.UserObj === 'free',  
        'memberUser': item.UserObj === 'member', 
        'move': move, 
        'selected': item.selected
      }"
    >
      <span>{{moment(item.pubDate, 'YYYYMMDD').format('ddd, MMM D, YYYY')}}</span>
      <span *ngIf="item.soldOut"> - SOLD OUT</span>
      <span *ngIf="item.UserObj === 'free'"> (Gold and Platinum only)</span>
      <span *ngIf="item.UserObj === 'member'"> (early access for you)</span>
      <!-- <span *ngIf="item.isMember"> - MEMBERS ONLY</span> -->
    </li>
  </ul>
</div>
